import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-quick-image-list-preview',
  templateUrl: './quick-image-list-preview.component.html',
  styleUrls: ['./quick-image-list-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, ImageLoaderModule],
})
export class QuickImageListPreviewComponent
  extends AliveState
  implements OnInit
{
  allPhotos = [];
  closed = new EventEmitter();
  context: ZalamoObject;
  contextId: string;
  @Input() currentIndex = 0;
  currentPhoto$ = new BehaviorSubject<{
    photoId: string;
    photoGroupId: string;
    label?: string;
  }>(null);
  labelClicked = new Subject<number>();
  constructor(private elementRef: ElementRef) {
    super();
  }

  close() {
    this.closed.emit();
  }

  next() {
    if (this.currentIndex === this.allPhotos.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }

    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    if (!this.allPhotos[this.currentIndex].photoId) {
      this.next();
    }
  }

  prev() {
    if (this.currentIndex === 0) {
      this.currentIndex = this.allPhotos.length - 1;
    } else {
      this.currentIndex--;
    }

    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    if (!this.allPhotos[this.currentIndex].photoId) {
      this.prev();
    }
  }

  ngOnInit(): void {
    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    this.subscribeWhileAlive(
      fromEvent<{
        target: HTMLElement;
        key: 'Escape' | 'ArrowRight' | 'ArrowLeft';
      }>(document.body, 'keydown').pipe(
        filter(
          ({ target, key }) =>
            target === this.elementRef.nativeElement ||
            target.contains(this.elementRef.nativeElement) ||
            this.elementRef.nativeElement.contains(target),
        ),
        tap((x) => {
          switch (x.key) {
            case 'Escape':
              this.close();
              break;
            case 'ArrowRight':
              this.next();
              break;
            case 'ArrowLeft':
              this.prev();
              break;
          }
        }),
      ),
    );
  }

  labelClickedAction() {
    this.labelClicked.next(this.currentIndex);
  }
}
